import React from "react";
import { Login } from "react-admin";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import uiConfig from "../config/firebaseUI";
import { getAuth } from "firebase/auth";
import { firebaseApp } from "../config/firebaseAuthProvider";

function CustomLoginPage() {
	return (
		<Login>
			<StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={getAuth(firebaseApp)} />
		</Login>
	);
}

export default CustomLoginPage;
